<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 38 38"
		xmlns="http://www.w3.org/2000/svg"
		class="text-primary animate-spin"
	>
		<defs>
			<linearGradient id="gradient" x1="8.042%" y1="0%" x2="65.682%" y2="23.865%">
				<stop stop-color="currentcolor" stop-opacity="0" offset="0%" />
				<stop stop-color="currentcolor" stop-opacity=".631" offset="63.146%" />
				<stop stop-color="currentcolor" offset="100%" />
			</linearGradient>
		</defs>
		<g fill="none" fill-rule="evenodd" transform="translate(1 1)">
			<path d="M36 18 c0 -9.94 -8.06 -18 -18 -18" stroke="url(#gradient)" stroke-width="2" />
		</g>
	</svg>
</template>

<script lang="ts" setup>
export interface Props {
  size?: number
}

withDefaults(defineProps<Props>(), {
  size: 38,
});
</script>
